export default __webpack_public_path__ + "static/media/garbage-disposal.f4cba693.svg";